import { defineStore } from 'pinia'
import { ref } from 'vue'
import { requestGetMemberEnabledModules } from '@/api/memberModules/memberModules'
import { MemberEnabledModulesVo } from '@/api/memberModules/memberModulesType'

/**
 * 会员端模块开关状态
 * 登录成功后按当前俱乐部拉取，用于判断会员端相关入口或功能是否展示。
 */
export const useMemberModulesStore = defineStore(
  'memberModules',
  () => {
    // 当前俱乐部的会员端模块开关原始数据
    const enabledModules = ref<MemberEnabledModulesVo>({})
    // 只要任意模块开启，就认为当前俱乐部存在会员端能力
    const isMemberModuleEnabled = computed(() => enabledModules.value.modules?.some(item => item.enabled === true) || false)

    // 拉取指定俱乐部的会员端模块开关
    async function fetchEnabledModules(requestClubId: string) {
      if (!requestClubId) {
        return
      }

      const { data } = await requestGetMemberEnabledModules({ requestClubId })
      enabledModules.value = data
    }

    // 清空模块开关，通常用于退出登录
    function resetEnabledModules() {
      enabledModules.value = {}
    }

    return {
      enabledModules,
      isMemberModuleEnabled,
      fetchEnabledModules,
      resetEnabledModules,
    }
  },
  {
    persist: true,
  },
)
